import {IonButton, IonButtons, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonLabel, IonList, IonMenuButton, IonNote, IonPage, IonRefresher, IonRefresherContent, IonRouterLink, IonRow, IonSegment, IonSegmentButton, IonTitle, IonToolbar, RefresherEventDetail, useIonRouter} from '@ionic/react';
import {capitalize, productInfo} from '../utils';
import {useStoreState} from 'pullstate';


import {fetch_Pg_6_1, fetch_Pg_6_2, Pg_6_1_Store, Pg_6_2_Store, Pg_6_3_Store, push_pg_6_2} from "../store/Pg_6_Store";
import {getPageData, getQuotes} from "../store/Selectors";
import {Fragment, useEffect, useRef, useState} from "react";
import {QuoteItem} from "../components/QuoteItem";
import {ContractItem} from "../components/ContractItem";
import {fetch_pg_1_2} from "../store/Pg_1_Store";
import {checkmarkOutline, chevronDownCircleOutline} from "ionicons/icons";
import {TokenStackItem} from "../components/TokenStackItem";
import {useAppUtil, useSideMenuOptions, useSideMenuUpdate} from "../components/sideMenu/SideMenuProvider";
import {tab1SideMenu} from "../components/sideMenu/PageSideMenus";
import {PageHeader} from "./PageHeader";
import {Modal} from "./Modal";
import CustomPage from "./CustomPage";
import {TokenEnwItem} from "../components/TokenEnwItem";
import {TokenEnwEntrustListItem} from "../components/TokenEnwEntrustListItem";
import {useParams} from "react-router";
import {useLoginFields} from "./Pg_A_1";
import {useFormInput, validateForm} from "../_/useForms";
import indexBy from "underscore/modules/indexBy";
import styles_TokenItem from "../components/CheckableTokenItem.module.scss";
import {fetch_pg_0_3} from "../store/Pg_0_Store";
import {handleFetchCommonErrors, navAwayToPg_6_1, navAwayToPg_A_1} from "./Utils";
import CustomField from "../components/CustomField";
import {Pg_B_1_Store} from "../store/Pg_B_Store";
import {Pg_C_4_Store, push_pg_C_1} from "../store/Pg_C_Store";
import {CheckableTokenEnwItem} from "../components/CheckableTokenEnwItem";
import ClassNames from "../components/ClassNames";


export const useRegisterFields = () => {
    return [
        {
            id: "p1",
            label: "TokenEnwId組",
            required: false,
            input: {
                props: {
                    type: "text",
                    placeholder: "TokenEnwId組",
                },
                state: useFormInput("")
            },
            checkedList: useRef<any[]>([]),
        },
        {
            id: "p2",
            label: "撥放清單名稱",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "撥放清單名稱",
                },
                state: useFormInput("")
            }
        },
        {
            id: "p3",
            label: "背景色",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "背景色",
                },
                state: useFormInput("#FFFFFF")
            }
        },
        {
            id: "p4",
            label: "播放間隔秒",
            required: true,
            input: {
                props: {
                    type: "text",
                    placeholder: "播放間隔秒",
                },
                state: useFormInput("60")
            }
        },
    ];
}

const Pg_6_2 = (props) => {
    const pageRef = useRef();
    const pageName = "Pg_6_2";
    const pageId = "Pg_6_2";
    const {sideMenuOptions} = props;
    const setSideMenu: any = useSideMenuUpdate();
    const sideMenu: any = useSideMenuOptions();

    const router = useIonRouter();

    const {param_playlistId}: any = useParams();

    const [playlistId, setPlaylistId] = useState<any>(param_playlistId);

    useEffect(() => {
        setSideMenu({options: sideMenuOptions, side: "start", pageName: pageId});
    }, []);

    //#region Data Loading
    const fields = useRegisterFields();
    let keyedFields = indexBy(fields, 'id');
    const [errors, setErrors] = useState(false);

    useEffect(() => {
        (async () => {
            let errorObj = await fetch_Pg_6_2({});
            handleFetchCommonErrors(router, errorObj);
        })();
    }, []);

    let reload = async (event?: CustomEvent<RefresherEventDetail>) => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        let errorObj = await fetch_Pg_6_2({});
        handleFetchCommonErrors(router, errorObj);
        event?.detail?.complete();
    }

    const pgData = useStoreState(Pg_6_2_Store, getPageData);
    const [amountLoaded, setAmountLoaded] = useState(20);
    const [selectedProduct, setSelectedProduct] = useState(false);

    useEffect(() => {
        if (pgData?.reload == true) {
            Pg_6_2_Store.replace({});
            reload();
        }
    }, [pgData]);

    let hasLoaded = pgData?.Root ?? false;
    //hasLoaded = true;
    const List_TokenEnw = hasLoaded ? pgData.Root.List_TokenEnw : undefined;
    //let RegionLockMessage = hasLoaded ? pgData.Root.RegionLockMessage : undefined;
    let RegionLockMessage = null;
    //#endregion


    //#region +Event

    //#region click_全部委託
    const click_全部委託 = async () => {
        const navToPg_5_1 = () => {
            router.push("/tabs/5_1", "forward", "push");
        }
        navToPg_5_1();
        return false;
    }
    //#endregion

    //#region click_我的委託
    const click_我的委託 = async () => {
        const navToPg_5_5 = () => {
            router.push("/tabs/5_5", "forward", "push");
        }
        navToPg_5_5();
        return false;
    }
    //#endregion

    //#region click_標記委託
    const click_標記委託 = async () => {
        const navToPg_5_7 = () => {
            router.push("/tabs/5_7", "forward", "push");
        }
        navToPg_5_7();
        return false;
    }

    const push_register = async () => {
        //if (agreementRef.current.value =)
        const errors = validateForm(fields);
        setErrors(errors);

        if (keyedFields.p1.checkedList.current.length === 0) {
            alert('最少要選取一個 [顯示的3D模組] ');
            return;
        }

        if (errors.length >= 1) {
            alert('欄位沒寫完成，請檢視 (欄位右側有註解缺甚麼)');
            return;
        }

        // if (!agreementRef?.current?.checked) {
        //     alert('需要勾選同意會員條款');
        //     return;
        // }

        if (!errors.length) {
            //  Submit your form here
            const p2 = fields && (keyedFields.p2 as any).input.state.value;
            const p3 = fields && (keyedFields.p3 as any).input.state.value;
            const p4 = fields && (keyedFields.p4 as any).input.state.value;

            //const password = fields && (fields.filter(e => e.id === 'password')[0] as any).input.state.value;
            //const password = fields && (fields.filter(e => e.id === 'password')[0] as any).input.state.value;


            try {
                if (await push_pg_6_2({
                    p1: keyedFields.p1.checkedList.current.join(','),
                    p2,
                    p3,
                    p4,
                })) {
                    alert('建立完成');
                    navAwayToPg_6_1(router);
                }
            } catch (err) {

            }
        }
    }


    //#endregion

    //#endregion

    return (
        <IonPage id={pageId}>
            <CustomPage name={pageId} sideMenu={false} sideMenuPosition="start" backButton={false}>
                <IonRefresher slot="fixed" onIonRefresh={reload}>
                    <IonRefresherContent
                        pullingIcon={chevronDownCircleOutline}
                        pullingText="Pull to refresh"
                        refreshingSpinner="circles"
                        refreshingText="Refreshing...">
                    </IonRefresherContent>
                </IonRefresher>

                {hasLoaded && <Fragment>
                    {RegionLockMessage ?
                        <>
                            <IonGrid>
                                <IonRow>
                                    <IonCol className="ion-justify-content-center ion-text-center w100 ion-padding">
                                        {RegionLockMessage}
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                        </> : <>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        新增撥放清單
                                    </IonCol>
                                </IonRow>
                            </IonGrid>


                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        1. 打勾想要顯示的3D模組
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        <div></div>
                                        <div className={ClassNames(styles_TokenItem.coverImageContainer, pageId)}>
                                            {List_TokenEnw.map((item, index) => {
                                                return <Fragment key={item.TokenEnwId}>
                                                    <CheckableTokenEnwItem Item_TokenEnwItem={item} field={keyedFields.p1}/>
                                                </Fragment>
                                            })}
                                        </div>
                                    </IonCol>
                                </IonRow>
                            </IonGrid>

                            <IonGrid>
                                <IonRow>
                                    <IonCol>
                                        2. 填寫必要資料
                                    </IonCol>
                                </IonRow>
                            </IonGrid>
                            <IonRow>
                                <IonCol>
                                    <CustomField field={keyedFields.p2} errors={errors}/>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                    <CustomField field={keyedFields.p3} errors={errors}/>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                    <CustomField field={keyedFields.p4} errors={errors}/>
                                </IonCol>
                            </IonRow>

                            <IonRow className="ion-margin-top ion-padding-top">
                                <IonCol size="12">
                                    <IonButton className="custom-button" expand="block" onClick={() => push_register()}>確定新增</IonButton>
                                </IonCol>
                            </IonRow>

                            {/*<IonRouterLink routerLink={`/5_1`}>*/}
                            {/*    <IonButton fill={"solid"}>*/}
                            {/*        <IonIcon icon={checkmarkOutline}/>*/}
                            {/*        &nbsp;全部委託 跳到5_1*/}
                            {/*    </IonButton>*/}
                            {/*</IonRouterLink>*/}

                            {/*<IonRouterLink routerLink={`/5_5`}>*/}
                            {/*    <IonButton fill={"solid"}>*/}
                            {/*        <IonIcon icon={checkmarkOutline}/>*/}
                            {/*        &nbsp;我的委託 跳到5_5*/}
                            {/*    </IonButton>*/}
                            {/*</IonRouterLink>*/}

                            {/*<IonRouterLink routerLink={`/5_7`}>*/}
                            {/*    <IonButton fill={"solid"}>*/}
                            {/*        <IonIcon icon={checkmarkOutline}/>*/}
                            {/*        &nbsp;標記委託 跳到5_7*/}
                            {/*    </IonButton>*/}
                            {/*</IonRouterLink>*/}

                            {/*<IonGrid className="ion-padding">*/}
                            {/*    /!*<IonRow className={ styles.searchContainer }>*!/*/}
                            {/*    /!*    <IonCol size="12">*!/*/}
                            {/*    /!*        <IonSearchbar animated placeholder="Search for a product" />*!/*/}
                            {/*    /!*    </IonCol>*!/*/}
                            {/*    /!*</IonRow>*!/*/}


                            {/*    /!*click={() => handleShowModal(item)}*!/*/}
                            {/*    <div className={styles_TokenItem.coverImageContainer}>*/}
                            {/*        {List_Token.map((item, index) => {*/}
                            {/*            return <Fragment key={item.TokenId}>*/}
                            {/*                <TokenStackItem Item_Token={item}/>*/}
                            {/*            </Fragment>*/}
                            {/*        })}*/}
                            {/*    </div>*/}
                            {/*</IonGrid>*/}


                        </>}
                </Fragment>}
            </CustomPage>
        </IonPage>
    );
};

export default Pg_6_2;
